import { render, staticRenderFns } from "./BenefitPeriodAvailability.vue?vue&type=template&id=0373c102&"
import script from "./BenefitPeriodAvailability.vue?vue&type=script&lang=js&"
export * from "./BenefitPeriodAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports